import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungKonstanz() {
  return (
    <CityPageTemplate
      city="Konstanz"
      slug="konstanz"
      intro="Konstanz am Bodensee – in einer der schönsten Lagen Deutschlands beraten wir Dich für eine sichere finanzielle Zukunft."
      description="Unabhängige & digitale Finanzberatung für Konstanz: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
